"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Price = void 0;
var _presentationHttp = require("@ori/presentation-http");
var _presentationProductDetail = require("@ori/presentation-product-detail");
var _internal = require("../../../hooks/internal");
var _jsxRuntime = require("react/jsx-runtime");
const Price = () => {
  const {
    currentShade
  } = (0, _internal.useProduct)();
  const {
    customerTypeId
  } = (0, _presentationHttp.useUserSegmentationData)();
  const {
    isMrpStatementEnabled
  } = (0, _internal.useSharedConfiguration)();
  const {
    price: {
      current,
      old,
      priceAfterImmediateDiscount
    }
  } = currentShade;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_presentationProductDetail.PriceSection, {
    cataloguePrice: old,
    currentPrice: current,
    priceAfterImmediateDiscount: priceAfterImmediateDiscount,
    customerTypeId: customerTypeId,
    mrpStatementEnabled: isMrpStatementEnabled,
    size: "small"
  });
};
exports.Price = Price;